import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterLink } from '@angular/router';

import { StructuredAlertComponent } from './structured-alert.component';

@NgModule({
  declarations: [StructuredAlertComponent],
  exports: [StructuredAlertComponent],
  imports: [CommonModule, RouterLink],
})
export class StructuredAlertModule {}
